<script lang="ts">
  import { setAuth } from "../lib/api";
  import { loadSnapshot } from "../lib/store";

  let baseUrl = $state("https://second-brain-api.ryans-second-brain.workers.dev");
  let token = $state("");
  let saving = $state(false);
  let error = $state("");

  async function save(e: Event) {
    e.preventDefault();
    error = "";
    if (!baseUrl.trim() || !token.trim()) {
      error = "Both fields are required.";
      return;
    }
    saving = true;
    setAuth(baseUrl.trim(), token.trim());
    await loadSnapshot();
    saving = false;
  }
</script>

<div class="setup">
  <h1>Surface</h1>
  <p class="muted">Visible surface over the Second Brain. One-time setup.</p>

  <form onsubmit={save}>
    <label>
      <span>Worker base URL</span>
      <input type="url" bind:value={baseUrl} placeholder="https://...workers.dev" autocomplete="off" autocapitalize="off" />
    </label>

    <label>
      <span>API key</span>
      <input type="password" bind:value={token} placeholder="paste API_KEY" autocomplete="off" autocapitalize="off" />
    </label>

    {#if error}
      <p class="error">{error}</p>
    {/if}

    <button type="submit" class="primary" disabled={saving}>
      {saving ? "Saving…" : "Save & continue"}
    </button>
  </form>

  <p class="faint">
    Stored in this device's localStorage. Both fields can be updated later from Settings.
  </p>
</div>

<style>
  .setup {
    max-width: 420px;
    margin: 0 auto;
    padding: calc(48px + var(--safe-top)) 20px 20px;
  }
  h1 { font-size: 32px; margin: 0 0 4px; letter-spacing: -0.02em; }
  form { display: flex; flex-direction: column; gap: 16px; margin-top: 32px; }
  label { display: flex; flex-direction: column; gap: 6px; }
  label span { font-size: 13px; color: var(--fg-dim); text-transform: uppercase; letter-spacing: 0.04em; }
  .primary {
    background: var(--accent);
    color: var(--accent-fg);
    padding: 14px;
    border-radius: 10px;
    font-weight: 600;
    margin-top: 8px;
  }
  .primary:disabled { opacity: 0.6; }
  .error { color: var(--priority-high); font-size: 14px; }
</style>
